let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
    let templateName = document.body.getAttribute('data-template');
  // Dynamically load JavaScript files
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/event.js?v=129793407935769848231762866286");
  loadScript("https://bridge.shopflo.com/js/shopflo.bundle.js");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/devx-script.js?v=51549546263141444671762866312");  
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/all.min.js?v=155899187558914370431762866283");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/product-form.js?v=120457291108000046811762866285");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/cart-notification.js?v=133508293167896966491762866282");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/search-form.js?v=133129549252120666541762866282");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/quantity-popover.js?v=987015268078116491762866283");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/shop-all.js?v=143197897513113412691762866312");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/quick-add.js?v=73073840428863680991762866284");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/facets.js?v=46295235780883033701762866286");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/show-more.js?v=135784227224860024771762866282");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/st_offers.js?v=86427977999770493551763148580");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/predictive-search.js?v=162273246065392412141762866284");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/dk-internal.js?v=48562600647143429831762875465");

 
  

  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/quantity-popover.css?v=76231206801088522361762866282");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/npdp-color-swatch.css?v=141246657724163601551763015414");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/all.min.css?v=36347114306294163891762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-price.css?v=70172745017360139101762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-card.css?v=158102377163184793191762866286");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-cart.css?v=49529066954642232561762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-mega-menu.css?v=122458266873942644791762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-totals.css?v=45024014013762792871762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-cart-drawer.css?v=71577824717805454931762877476");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-discounts.css?v=152760482443307489271762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/searchtap.css?v=111603181540343972631762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-list-menu.css?v=151968516119678728991762866286");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-search.css?v=165164710990765432851762866285");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-menu-drawer.css?v=20646116693146970981762866284");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-cart-notification.css?v=54116361853792938221762866282");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-cart-items.css?v=47901327362710772261762866282");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-collection-hero.css?v=150137544140055157131762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/quick-add.css?v=66647833350618835731762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-show-more.css?v=139536189637226996221762866285");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-swatch-input.css?v=61683592951238328641762866282");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/component-swatch.css?v=68619770617697936771762866283");
  loadCSS("//www.dotandkey.com/cdn/shop/t/1881/assets/cart-drawer-new-ui-extra-css.css?v=34207706789026692801762879905");
   
  // Remove invalid HTML and use JavaScript to load the script
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/details-modal.js?v=119528565511025453401762866283");
  loadScript("//www.dotandkey.com/cdn/shop/t/1881/assets/details-disclosure.js?v=13653116266235556501762866282");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);   
  }, 10);

}
// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true; // Ensure scripts are executed in order
  document.head.appendChild(script);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
